import { OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler, JWT } from '../../helpers';
import { DashboardService } from '../../dashboard';
import { Observable } from 'rxjs/Rx';
import { ErrorHandlerService } from '../../services';
var CreateTopicComponent = /** @class */ (function () {
    function CreateTopicComponent(dashboardService, errorHandlerService, router, route) {
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.route = route;
        this.text2 = '';
        this.Facebook = '';
        this.Twitter = '';
        this.createTopic = { topicDetailId: '', inputTopicPermission: 'OPEN' };
        this.topicPermissions = [];
        this.topicTypes = [];
        this.formData = new FormData();
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.facebookProviderUserId = -1;
        this.isFacebookAPIAuthorizationDeclined = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
    }
    CreateTopicComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    CreateTopicComponent.prototype.ngOnInit = function () {
        var _this = this;
        var s1 = this.dashboardService.topicPermissionType().subscribe(function (data) { console.log(data); _this.topicPermissions = data; }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
        var s2 = this.dashboardService.topicTypes().subscribe(function (data) { console.log(data); _this.topicTypes = data; }, function (error) {
            _this.handleError(error);
        });
        this.subscriptions.push(s2);
    };
    CreateTopicComponent.prototype.topicImageUpload = function (event) {
        var date = new Date();
        var fileList = event.target.files;
        if (fileList.length > 0) {
            var file = fileList[0];
            this.formData.append('topicPic', file, file.name);
        }
    };
    CreateTopicComponent.prototype.createTopicClick = function () {
        var _this = this;
        this.showSpinner = true;
        this.createTopic.shortTopicDescription = 'Demon';
        if (this.Facebook == '1' && this.Twitter == '1') {
            this.createTopic.inputTopicCreateActions = ['FACEBOOK ANNOUNCEMENTS', 'PUBLISH TO TWITTER'];
        }
        if (this.Facebook == '1' && this.Twitter == '') {
            this.createTopic.inputTopicCreateActions = ['FACEBOOK ANNOUNCEMENTS'];
        }
        if (this.Twitter == '1' && this.Facebook == '') {
            this.createTopic.inputTopicCreateActions = ['PUBLISH TO TWITTER'];
        }
        var s3 = this.dashboardService.uploadTopicImage(this.formData).subscribe(function (data) {
            console.log(data);
            _this.createTopic.topicDetailId = data.topicDetailId;
            _this.createTopic.topicImageUrl = data.topicImageUrl;
            console.log(_this.createTopic);
            //this.createTopic.inputTopicCreateActions = [];
            console.log(_this.createTopic);
            var s4 = _this.dashboardService.createTopic(_this.createTopic).subscribe(function (data) {
                console.log(data);
                if (data.isSocialAuthenticationRequired == true) {
                    // If you have opened the Facebook Window, then display Overlay
                    _this.showOnlyOverlay = true;
                    var url_1 = process.env.WEB_CONTROLLER_URL + "uvsity/redirectToFacebookAuthorization.do?jwtToken=" +
                        encodeURIComponent(JWT.jwtToken()) + "&isFacebookPostRequired=true&isTwitterPostRequired=false&topicId=" + data.topicDetailId;
                    console.log("the Facebook URL = " + url_1);
                    var width = 500;
                    var height = 650;
                    var leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
                    //Allow for title and status bars.
                    var topPosition = (window.screen.height / 2) - ((height / 2) + 50);
                    var fbAuthWindow_1 = window.open(url_1, "Authenticate with Facebook", "width=" + width + ",height=" + height +
                        ",left=" + leftPosition + ",top=" + topPosition);
                    if (fbAuthWindow_1 == null || typeof (fbAuthWindow_1) == 'undefined') {
                        _this.createInfoAlert("Please enable pop up blocker to perform Facebook authorization. The system will retry again after 2 minutes.");
                        Observable.interval(1000 * 60 * 2).subscribe(function (timerVal) {
                            var fbAuthWindowRetry = window.open(url_1, "Authenticate with Facebook", "width=" + width + ",height=" + height +
                                ",left=" + leftPosition + ",top=" + topPosition);
                            if (fbAuthWindowRetry == null || typeof (fbAuthWindowRetry) == 'undefined') {
                                _this.createInfoAlert("Pop Up Blocker still disabled. Unable to post Topic to Facebook.");
                                _this.showSpinner = false;
                                _this.router.navigate(['dashboard/mytopics']);
                            }
                            else {
                                _this.facebookPostAuthWindowOpenCheckerSubscriber = Observable.interval(2000).subscribe(function (x) {
                                    _this.checkFacebookAuthorizationCompletionStatus(fbAuthWindowRetry);
                                });
                            }
                        });
                    }
                    else {
                        _this.facebookPostAuthWindowOpenCheckerSubscriber = Observable.interval(2000).subscribe(function (x) {
                            _this.checkFacebookAuthorizationCompletionStatus(fbAuthWindow_1);
                        });
                    }
                }
                else {
                    // Stop showing Spinner
                    _this.showSpinner = false;
                    _this.router.navigate(['dashboard/mytopics']);
                }
            }, function (error) {
                // Stop showing Spinner
                _this.showSpinner = false;
                _this.handleError(error);
            });
            _this.subscriptions.push(s4);
        }, ErrorHandler.handelError);
        this.subscriptions.push(s3);
    };
    CreateTopicComponent.prototype.checkFacebookAuthorizationCompletionStatus = function (fbAuthWindow) {
        var _this = this;
        console.log('Checking if Facebook call completed. Window CLosed?' + fbAuthWindow.closed);
        var s5 = this.dashboardService.loggedInUser().subscribe(function (data) {
            _this.facebookProviderUserId = data.facebookProviderUserId;
            _this.isFacebookAPIAuthorizationDeclined = data.isFacebookAuthorizationDeclined;
            console.log("facebookProviderUserId, isFacebookAPIAuthorizationDeclined from loggedInUser API ==>"
                + _this.facebookProviderUserId + ", " + _this.isFacebookAPIAuthorizationDeclined);
            if (_this.isFacebookAPIAuthorizationDeclined) {
                _this.showSpinner = false;
                _this.facebookPostAuthWindowOpenCheckerSubscriber.unsubscribe();
                // Display a Modal Dialog saying that the Google Authorization was declined. Route back to Home Page after that.
                _this.createInfoAlert("Unable to post your topic on Facebook as the credentials provided to Facebook were not correct");
                _this.router.navigate(['dashboard/mytopics']);
            }
            else if (_this.facebookProviderUserId !== null && _this.facebookProviderUserId >= 0) {
                _this.showSpinner = false;
                _this.facebookPostAuthWindowOpenCheckerSubscriber.unsubscribe();
                console.log("The Facebook API Connectiion ID is " + _this.facebookProviderUserId + ", about to fetch Google Contacts");
                _this.createInfoAlert("We have successfully posted the topic you just created, on Facebook, for you to share with your friends.");
                _this.router.navigate(['dashboard/mytopics']);
            }
            else if (fbAuthWindow.closed) {
                _this.showSpinner = false;
                _this.facebookPostAuthWindowOpenCheckerSubscriber.unsubscribe();
                _this.createInfoAlert("Unable to post your topic on Facebook as the Facebook Authorization window was prematurely closed.");
                _this.router.navigate(['dashboard/mytopics']);
            }
        }, function (error) {
            console.log(error);
            _this.handleError(error);
        });
        this.subscriptions.push(s5);
    };
    CreateTopicComponent.prototype.closeTopicCreateStatusPopup = function () {
        this.showSpinner = false;
        this.router.navigate(['dashboard/mytopics']);
    };
    CreateTopicComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    CreateTopicComponent.prototype.handleError = function (error) {
        this.showSpinner = false;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    CreateTopicComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return CreateTopicComponent;
}());
export { CreateTopicComponent };
//# sourceMappingURL=createtopic.component.js.map